import { readFileAsBuffer } from '@/utils/oss'
import { axios } from '@/utils/request'

const api = {
  addTask: '/619217f68e3d2',
  updateTask: '/5d9d9f0c0072f',
  getTaskList: '/61921e1cbbedd',
  getMemberList: '/619202bdc83fb',
  getTask: '/5d9f049faecaa',
  removeTask: '/5d9fe77a02270',
  updateTaskStatus: '/5da0419ab2bb7',
  addGroupToTask: '/6357b6dd7a6d4', // 会员列表--将该分组加入群发列表
  addUserToTask: '/6191f1b92a41b',
  clearList: '/619348a0b6ed2',
  // 获取群发机器人列表
  getRobotList:'/62b15db1ddf7c'
}

export default {
  // 更新机器人更新日志列表
  getMemberList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })
    return axios({
      url: api.getMemberList,
      method: 'get',
      params: params
    }).then(res => {
      return {
        showList:{
          data: res.data.list || [],
          pageNo: parameter.pageNo,
          pageSize: parameter.pageSize,
          totalCount: res.data.count
        },
        params:{
          failed_count:res.data.failed_count,
          finished_count:res.data.finished_count,
          unfinished_count:res.data.unfinished_count,
          count:res.data.count
        }
      }
    })
  },
  // 新增任务
  addTask: params => {
    return axios({
      url: api.addTask,
      method: 'post',
      data: params
    })
  },
  // 清空群发列表
  clearList: params => {
    return axios({
      url: api.clearList,
      method: 'post',
      data: params
    })
  },
  // 更新任务
  updateTask: params => {
    return axios({
      url: api.updateTask,
      method: 'post',
      data: params
    })
  },
  addUserToTask: params =>
    axios({
      url: api.addUserToTask,
      method: 'post',
      data: params
    }),
  // 将该分组加入群发列表
  addGroupToTask: params =>
    axios({
      url: api.addGroupToTask,
      method: 'get',
      params: params
    }), 

  // 获取任务
  getTask: params => {
    return axios({
      url: api.getTaskList,
      method: 'get',
      params
    })
  },
  // 删除任务
  removeTask: params => {
    return axios({
      url: api.removeTask,
      method: 'get',
      params: params
    })
  },
  // 更新任务状态
  updateTaskStatus: params => {
    return axios({
      url: api.updateTaskStatus,
      method: 'get',
      params: params
    })
  },
  // 获取群发任务的机器人列表
  getRobotList:parameter=>{
    const params = Object.assign(parameter,{page:parameter.pageNo||1})
    return axios({
      url:api.getRobotList,
      method:'get',
      params
    }).then(res=>{
      return {
        data: res.data || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.length,
        msg:res.msg
      }
    })
  }
}
